const AgencyJobLabel = Object.freeze({
  manager: 'Gérant',
  projectManager: 'Chargée de projet',
  administrativeAssistant: 'Assistant administratif',
});

export default AgencyJobLabel;
